import { useQuery } from '@tanstack/react-query';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string, familyId?: string, archived?: boolean) {
  return useQuery<ConversationListItem[]>({
    // archived is left undefined (not false) for the main list so the queryKey and request URL stay
    // identical to before; the archived view passes true, giving it its own cache entry.
    queryKey: ['conversations', { clientId, familyId, archived }],
    // Poll while the list is open so a turn moving to processing, then unread, shows without a manual refresh.
    refetchInterval: 4000,
  });
}
